import React, { useState } from 'react';

import PageContainer from 'pages/MyAccount/shared-components/PageContainer/PageContainer';
import PersonalInformation from './PersonalInformation';
import ShippingAddresses from './ShippingAddresses';
import styles from './AccountDetailsPage.module.css';
import Credits from './Credits/Credits';
import Payment from './Payment/Payment';
import ManageMembership from './ManageMembership/ManageMembership';

const AccountDetailsPage = ({
  firstName,
  lastName,
  phone,
  email,
  shippingAddress,
  credits,
  billingInfo,
  setBillingInfo,
  isSocialUser,
  isClubMember,
}) => {
  const {
    address1,
    address2,
    city,
    region,
    code: zipcode,
    country,
  } = shippingAddress || {};

  const formState = {
    firstName,
    lastName,
    phone,
    email,
    address1,
    address2,
    city,
    region,
    zipcode,
    country,
  };

  const [formData, setFormData] = useState(formState);

  const updateUserInfo = (data) => {
    setFormData((prevState) => {
      return { ...prevState, ...data };
    });
  };

  return (
    <PageContainer>
      <div className={styles.container} data-testid="account-details-container">
        <div className={styles.header} data-testid="account-details-header">
          <h1>Account Details</h1>
        </div>
        <PersonalInformation
          firstName={formData.firstName}
          lastName={formData.lastName}
          email={formData.email}
          updateUserInfo={updateUserInfo}
        />
        <ShippingAddresses
          firstName={formData.firstName}
          lastName={formData.lastName}
          phone={formData.phone}
          address1={formData.address1}
          address2={formData.address2}
          city={formData.city}
          region={formData.region}
          zipcode={formData.zipcode}
          country={formData.country}
          updateUserInfo={updateUserInfo}
        />
        <Payment billingInfo={billingInfo} setBillingInfo={setBillingInfo} />
        <Credits credits={credits} />
        {!isSocialUser && !isClubMember && <ManageMembership />}
      </div>
    </PageContainer>
  );
};
export default AccountDetailsPage;
